<template>
  <div class="new-guide-step-2">
    <form-item label="过程事件" tips="一般为广告点击、坑位点击等运营相关的事件">
      <div class="link-attribute-switch" v-if="localPreAssociatedEvent.length">
        <t-switch size="small" v-model="isLinkAttr" @change="handleChangeIsLinkAttr"></t-switch>
        <span style="margin-left: 10px; font-size: 12px">关联属性</span>
        <t-tooltip class="item" content="选择是否关联属性" placement="top">
          <icon name="help-circle" style="margin-left: 10px; font-size: 12px; color: #888" />
        </t-tooltip>
      </div>
      <div v-for="(localPreAssociatedEventItem, index) in localPreAssociatedEvent" :key="index" class="pre-event-item">
        <div class="pre-event" :class="{ 'pb-0': localPreAssociatedEventItem.conditionModels.length }">
          <div class="pre-event-row">
            <t-select
              v-model="localPreAssociatedEventItem.eventName"
              placeholder="请选择"
              class="pre-event-select"
              :class="{ 'red-tips': equalPreEventAndToEventName(index) }"
              @change="handleEventNameChange(index)"
              filterable
            >
              <t-option
                v-for="item in eventList"
                :key="item.id"
                :label="item.eventShowName"
                :value="item.eventName"
              ></t-option>
            </t-select>
            <t-button
              @click="handleAddFilterItem(index)"
              class="btn-filter"
              variant="outline"
              :disabled="localPreAssociatedEventItem.conditionModels.length >= 5"
            >
              <icon name="add" slot="icon"></icon>
              筛选项
            </t-button>
            <icon name="delete" class="remove-btn" @click="handleDeletePreEvent(index)" />
          </div>
          <div class="ref-event-row" v-if="isLinkAttr">
            <t-select
              filterable
              v-model="localPreAssociatedEventItem.associatedProperty.source.column"
              class="ref-event-select"
              :class="{ 'red-tips': !equalColumnJavaType(index) }"
              placeholder="请选择"
              @change="
                value => {
                  handleAssociatedPropertyChange(index, 'source', value);
                }
              "
            >
              <t-option label="不关联" value=""></t-option>
              <t-option
                v-for="(item, index) in conditionPropertyOptions"
                :key="index"
                :label="item.propertyDesc"
                :value="item.propertyName"
              ></t-option>
            </t-select>
            <div class="ref-event-row-link" v-if="localPreAssociatedEventItem.associatedProperty.source.column">
              须与目标事件
              <t-select
                filterable
                v-model="localPreAssociatedEventItem.associatedProperty.target.column"
                class="ref-event-select"
                :class="{ 'red-tips': !equalColumnJavaType(index) }"
                placeholder="请选择"
                @change="
                  value => {
                    handleAssociatedPropertyChange(index, 'target', value);
                  }
                "
              >
                <t-option
                  v-for="(item, index) in conditionPropertyOptions"
                  :key="index"
                  :label="item.propertyDesc"
                  :value="item.propertyName"
                ></t-option>
              </t-select>
              的值相同
            </div>
          </div>
        </div>

        <div
          class="filter"
          style="padding: 10px 0 10px 52px; background-color: #fafafa"
          v-if="localPreAssociatedEventItem.conditionModels.length"
        >
          <ConditionFilter
            :filter-type.sync="localPreAssociatedEventItem.connectors"
            :filter-list="localPreAssociatedEventItem.conditionModels"
            :condition-operator-options="conditionOperatorOptions"
            :condition-property-options="conditionPropertyOptions"
            :all-event-event-property-list="allEventEventPropertyList"
            :filter-events="localPreAssociatedEventItem.eventName"
          />
        </div>
      </div>
      <t-button
        @click="handleAddPreEvent"
        class="btn-filter"
        variant="outline"
        :disabled="localPreAssociatedEvent.length >= 5"
      >
        <icon name="add" slot="icon"></icon>
        增加过程事件
      </t-button>
    </form-item>
  </div>
</template>

<script>
import lodash from 'lodash';
import FormItem from './form-item.vue';
import AssociateProperty from './associate-property.vue';
import ConditionFilter from '@/components/analysis/condition-filter.vue';

export default {
  name: 'process-event',
  components: {
    FormItem,
    ConditionFilter,
    AssociateProperty,
  },
  model: {
    prop: 'preAssociatedEvent',
    event: 'change',
  },
  props: {
    preAssociatedEvent: {
      type: Array,
      default: () => [],
    },
    targetEvent: {
      type: Object,
    },
    toAttributeEvent: {
      type: Array,
      default: () => [],
    },
    eventList: {
      type: Array,
      default: () => [],
    },
    conditionPropertyOptions: {
      type: Array,
      default: () => [],
    },
    conditionOperatorOptions: {
      type: Array,
      default: () => [],
    },
    targetName: {
      type: String,
    },
    allEventEventPropertyList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isLinkAttr: false,
      localPreAssociatedEvent: lodash.cloneDeep(this.preAssociatedEvent),
    };
  },
  computed: {
    eventNameAndShowNameMap() {
      return this.eventList.reduce((total, item) => {
        total[item.eventName] = item.eventShowName;
        return total;
      }, {});
    },
    columnNameAndShowNameMap() {
      return this.conditionPropertyOptions.reduce((total, item) => {
        total[item.propertyName] = item.propertyDesc;
        return total;
      }, {});
    },
    columnNameAndJavaTypeMap() {
      return this.conditionPropertyOptions.reduce((total, item) => {
        total[item.propertyName] = item.propertyDataType;
        return total;
      }, {});
    },
  },
  watch: {
    preAssociatedEvent: {
      handler() {
        if (JSON.stringify(this.preAssociatedEvent) !== JSON.stringify(this.localPreAssociatedEvent)) {
          this.localPreAssociatedEvent = lodash.cloneDeep(this.preAssociatedEvent);

          let isLinkAttr = false;
          this.localPreAssociatedEvent.forEach(item => {
            if (item.associatedProperty.source.column) {
              isLinkAttr = true;
            }
          });
          this.isLinkAttr = isLinkAttr;
        }
      },
      deep: true,
    },
    localPreAssociatedEvent: {
      handler() {
        this.$emit('change', lodash.cloneDeep(this.localPreAssociatedEvent));
      },
      deep: true,
    },
    targetEvent: {
      handler() {
        if (this.isLinkAttr) {
          this.localPreAssociatedEvent.forEach(item => {
            if (
              item.associatedProperty.source.column !== '' &&
              item.associatedProperty.target.eventName !== this.targetEvent.eventName
            ) {
              item.associatedProperty.target = {
                eventName: this.targetEvent.eventName,
                eventChineseName: this.targetEvent.eventChineseName,
                column: '',
                chineseName: '',
              };
            }
          });
        }
      },
      deep: true,
    },
  },
  methods: {
    handleChangeIsLinkAttr() {
      if (!this.isLinkAttr) {
        this.localPreAssociatedEvent.forEach(item => {
          item.associatedProperty.source = { eventName: '', eventChineseName: '', column: '', chineseName: '' };
          item.associatedProperty.target = { eventName: '', eventChineseName: '', column: '', chineseName: '' };
        });
      } else {
        this.localPreAssociatedEvent.forEach(item => {
          item.associatedProperty.source = {
            eventName: item.eventName,
            eventChineseName: item.eventChineseName,
            column: item.associatedProperty.source.column || '',
            chineseName: item.associatedProperty.source.chineseName || '',
          };
        });
      }
    },
    handleEventNameChange(index) {
      const { eventName } = this.localPreAssociatedEvent[index];
      const eventChineseName = this.eventNameAndShowNameMap[eventName];
      this.localPreAssociatedEvent[index].eventChineseName = eventChineseName || '';
      if (this.isLinkAttr) {
        this.localPreAssociatedEvent[index].associatedProperty.source.eventName = eventName;
        this.localPreAssociatedEvent[index].associatedProperty.source.eventChineseName = eventChineseName;
      }
    },
    handleAssociatedPropertyChange(index, type, column) {
      if (type === 'source') {
        this.localPreAssociatedEvent[index].associatedProperty.source.chineseName =
          this.columnNameAndShowNameMap[column] || '';
        this.localPreAssociatedEvent[index].associatedProperty.target.column = '';
        this.localPreAssociatedEvent[index].associatedProperty.target.chineseName = '';
        return;
      }
      this.localPreAssociatedEvent[index].associatedProperty.target.chineseName =
        this.columnNameAndShowNameMap[column] || '';
    },
    handleAddFilterItem(index) {
      if (this.localPreAssociatedEvent[index].conditionModels.length >= 5) {
        this.$message.warning('最多添加5个筛选项');
        return;
      }
      this.localPreAssociatedEvent[index].conditionModels.push({
        column: '',
        conditionOperator: '',
        value: undefined,
      });
    },
    handleAddPreEvent() {
      if (this.localPreAssociatedEvent.length >= 5) {
        this.$message.warning('最多添加5个过程事件');
        return;
      }
      this.localPreAssociatedEvent.push({
        eventName: '',
        eventChineseName: '',
        conditionModels: [],
        connectors: 'and',
        associatedProperty: {
          target: {
            eventChineseName: this.targetEvent.eventName || '',
            eventName: this.targetEvent.eventChineseName || '',
            column: '',
            chineseName: '',
          },
          source: {
            eventChineseName: '',
            eventName: '',
            column: '',
            chineseName: '',
          },
        },
      });
    },
    handleDeletePreEvent(index) {
      this.localPreAssociatedEvent.splice(index, 1);
    },
    equalColumnJavaType(index) {
      const { source, target } = this.localPreAssociatedEvent[index].associatedProperty;
      if (!source.column) {
        return true;
      }
      return this.columnNameAndJavaTypeMap[source.column] === this.columnNameAndJavaTypeMap[target.column];
    },
    equalPreEventAndToEventName(index) {
      const { eventName } = this.localPreAssociatedEvent[index];
      if (!eventName) {
        return false;
      }
      return !!this.toAttributeEvent.find(item => item.eventName === eventName);
    },
  },
};
</script>

<style lang="less">
.modal {
  border-radius: 4px;

  .el-dialog__body {
    padding-top: 0;
    padding-bottom: 0;
  }
}
</style>
<style lang="less" scoped>
@import './process-event';
</style>
